/*
 * サブシステム名：請求
 * 機能名：請求残高調整一覧
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'

import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'

const DdSearchList = () => import('@/components/DdSearchList')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDateBox = () => import('@/components/DdDateBox')

export default {
  name: 'SeikyuZandakaChoseiList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdDateBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {},
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0
  }),
  computed: {
    filteredRows () {
      return this.rows.map((elem) => {
        elem.konkaiSeikyuKingakuDisp = elem.konkaiSeikyuKingaku === 0 || elem.konkaiSeikyuKingaku ? filter.numericFormatter(elem.konkaiSeikyuKingaku) : null
        elem.seikyuYmdDisp = elem.seikyuYmd ? filter.dateFormatter(elem.seikyuYmd) : ''
        const insDateDisp = elem.insDate ? new Date(elem.insDate) : null
        elem.insDateDisp = insDateDisp ? filter.dateFormatter(insDateDisp) + ` ${`0${insDateDisp.getHours()}`.slice(-2)}:${`0${insDateDisp.getMinutes()}`.slice(-2)}` : ''
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      seikyusakiList: 'DDMasters/vwCMstTorihikisakiGetSeikyusaki'
    }),
    filteredSeikyusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.seikyusakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions,
        searchText: this.searchText,
        rows: this.rows
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['vwcmsttorihikisakigetseikyusaki'],
        defineHeaderPromise: () => {
          return new Promise((resolve) => {
            console.log('SeikyuZandakaChoseiList.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', align: 'center', sortable: false },
              { text: '請求先コード/名称', value: 'seikyusakiCdNm' },
              { text: '請求残高調整日', value: 'seikyuYmdDisp', align: 'center' },
              { text: '残高差額調整額', value: 'konkaiSeikyuKingakuDisp', align: 'end' },
              { text: '登録日時', value: 'insDateDisp', align: 'center' },
              { text: '登録担当者', value: 'tantoshaNm' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            console.log('initializeInputPromise')
            self.conditions = {
              searchSeikyusakiId: null,
              seikyuYmdString: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('SeikyuZandakaChoseiList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('SeikyuZandakaChoseiList.savedInputRestorePromise after loadFromCache', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('SeikyuZandakaChoseiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('SeikyuZandakaChoseiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2bild0050/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.conditions = {
              searchSeikyusakiId: null,
              seikyuYmdString: ''
            }
            self.searchText = ''
            self.rows = []
            self.selected = []
            self.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    }
  }
}
